// extracted by mini-css-extract-plugin
export default {"image_banner":"imageBanner_image_banner__xYSSY"};